
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/[slug]",
      function () {
        return require("private-next-pages/faq/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/[slug]"])
      });
    }
  